interface SectionHeadProps {
  eyebrow: string;
  title: string;
  desc?: string;
  dark?: boolean;
  center?: boolean;
}

export default function SectionHead({ eyebrow, title, desc, dark = false, center = false }: SectionHeadProps) {
  return (
    <div className={center ? 'mx-auto flex max-w-2xl flex-col items-center text-center' : 'flex max-w-2xl flex-col'}>
      <span className={`eyebrow ${dark ? 'text-honey-300' : 'text-ember-500'}`}>
        <span className={`h-px w-5 ${dark ? 'bg-honey-300/60' : 'bg-ember-400'}`}></span>
        {eyebrow}
      </span>
      <h2
        className={`display mt-3 text-2xl leading-snug md:text-4xl ${dark ? 'text-paper' : 'text-ink'}`}
      >
        {title}
      </h2>
      {desc && <p className={`mt-3 text-sm leading-relaxed md:text-[15px] ${dark ? 'text-cream/65' : 'text-clay'}`}>{desc}</p>}
    </div>
  );
}